import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import FileUpload from "../../components/file-upload";
import GenerateMetrics from "../../components/generate-metrics";
import Modal from "../../components/modal";
import { XIcon, ChevronDownIcon, FilterIcon } from "lucide-react";
import TradeMetrics from "../../components/trade-metrics";
import { finalMockData } from "../../utils/newMockData";
import apiClient from "../../utils/apiClient";
import server from "../../utils/serverConfig";

export default function PortfolioAnalyser() {
  const [currentTab, setCurrentTab] = useState("portfolio");
  const [showModal, setShowModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileStrategyList, setSelectedFileStrategyList] =
    useState(null);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [allMetricsData, setAllMetricsData] = useState(null);
  const [filteredTradeData, setFilteredTradeData] = useState(null);
  const [filteredMetricsData, setFilteredMetrcisData] = useState(null);
  const [filteredMonthlyPNLData, setFilteredMonthlyPNLData] = useState(null);
  const [filteredWeeklyPNLData, setFilteredWeeklyPNLData] = useState(null);
  const [filteredDayWisePNLData, setFilteredDayWisePNLData] = useState(null);
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  const fetchTradeMetrics = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-metrics`,
    };

    apiClient
      .request(config)
      .then((response) => {
        if (response.data.data.length !== 0) {
          // setMetrcisData(response.data.metrics_data);
          console.log("data", response);

          setAllMetricsData(response.data.data);
          setSelectedFile(response.data.data[0].file_name);
          setSelectedFileData(response.data.data[0].metrics_data);
          setSelectedFileStrategyList(response.data.data[0].strategy_list);

          setFilteredMetrcisData(response.data.data[0].metrics_data);

          setFilteredMonthlyPNLData(response.data.data[0].monthly_pnl_data);

          setFilteredWeeklyPNLData(response.data.data[0].weekly_pnl_data);

          setFilteredDayWisePNLData(response.data.data[0].day_wise_pnl);
          setFilteredTradeData(response.data.data[0].trade_data);

          setSelectedStrategy(
            response.data.data[0].strategy_list.reduce((acc, strategy) => {
              acc[strategy] = true; // Initially, all strategies are checked
              return acc;
            }, {})
          );
        } else {
          // setMetrcisData(null);
          setSelectedFile(null);

          setSelectedFileData(null);
        }

        // console.log("New Metrics -", response.data.metrics_data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // const fetchData = () => {
    //   console.log("Final", finalMockData);
    //   setAllMetricsData(finalMockData);
    //   setSelectedFile(finalMockData[0].file_name);
    //   setSelectedFileData(finalMockData[0].metrics_data);
    //   setSelectedFileStrategyList(finalMockData[0].strategy_list);

    //   setFilteredMetrcisData(finalMockData[0].metrics_data);

    //   setFilteredMonthlyPNLData(finalMockData[0].monthly_pnl_data);

    //   setFilteredWeeklyPNLData(finalMockData[0].weekly_pnl_data);

    //   setFilteredDayWisePNLData(finalMockData[0].day_wise_pnl);
    //   setFilteredTradeData(finalMockData[0].trade_data);

    //   setSelectedStrategy(
    //     finalMockData[0].strategy_list.reduce((acc, strategy) => {
    //       acc[strategy] = true; // Initially, all strategies are checked
    //       return acc;
    //     }, {})
    //   );
    // };
    fetchTradeMetrics();
    // fetchData();
  }, [showModal]);

  const handleShowDropdown = () => {
    setShowDropdown(true);
  };

  const handleCloseDropdown = () => {
    setShowDropdown(false);
  };

  const handleChangeTabs = (tabName) => {
    setCurrentTab(tabName);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSelectFile = (fileName) => {
    setSelectedFile(fileName);

    console.log("File name is --------", fileName);

    const data = allMetricsData.find((item) => item.file_name === fileName);

    console.log("Data is --------", data.metrics_data);
    if (data.metrics_data) {
      setSelectedFileData(data.metrics_data);
      setFilteredMetrcisData(data.metrics_data);
      setFilteredMonthlyPNLData(data.monthly_pnl_data);
      setFilteredWeeklyPNLData(data.weekly_pnl_data);
      setFilteredDayWisePNLData(data.day_wise_pnl);
      setSelectedFileStrategyList(data.strategy_list);
      setFilteredTradeData(data.trade_data);
      setSelectedStrategy(
        data.strategy_list.reduce((acc, strategy) => {
          acc[strategy] = true; // Initially, all strategies are checked
          return acc;
        }, {})
      );
    }
    handleCloseDropdown();
  };

  const handleFilterData = (
    newMetricsData,
    newMonthlyPnlData,
    newDayWisePnlData,
    newTradeData
  ) => {
    setFilteredMetrcisData(newMetricsData);
    setFilteredMonthlyPNLData(newMonthlyPnlData);
    setFilteredDayWisePNLData(newDayWisePnlData);
    setFilteredTradeData(newTradeData);
  };

  const handleResetFilter = (fileName) => {
    setSelectedFile(fileName);
    console.log("File name is --------", fileName);

    const data = allMetricsData.find((item) => item.file_name === fileName);

    console.log("Data is --------", data.metrics_data);
    
    if (data.metrics_data) {
      setSelectedFileData(data.metrics_data);
      setFilteredMetrcisData(data.metrics_data);
      setFilteredMonthlyPNLData(data.monthly_pnl_data);
      setFilteredWeeklyPNLData(data.weekly_pnl_data);
      setFilteredDayWisePNLData(data.day_wise_pnl);
      setSelectedFileStrategyList(data.strategy_list);
      setFilteredTradeData(data.trade_data);

      setSelectedStrategy(
        data.strategy_list.reduce((acc, strategy) => {
          acc[strategy] = true; // Initially, all strategies are checked
          return acc;
        }, {})
      );
    }
  };

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full ">
        <div className=" flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
          <div className="flex space-x-6">
            <div
              onClick={() => handleChangeTabs("portfolio")}
              className={` ${
                currentTab === "portfolio"
                  ? "text-[#07F2C7]  border-[#07F2C7]"
                  : "border-transparent"
              } flex items-center border-b-[4px]  text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in    `}
            >
              Portfolio Analyzer
            </div>
            <div
              onClick={() => handleChangeTabs("metrics")}
              className={` ${
                currentTab === "metrics"
                  ? "text-[#07F2C7]  border-[#07F2C7]"
                  : "border-transparent"
              } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
            >
              Trade Metrics
            </div>
          </div>

          {currentTab === "metrics" && (
            <div className="relative flex space-x-6 items-center">
              <div
                onClick={handleShowDropdown}
                className={` cursor-pointer flex items-center font-semibold text-white space-x-2 bg-zinc-800 px-4 py-2 rounded-md `}
              >
                View Metrics
                <ChevronDownIcon className="ml-2 h-5 w-5 text-white" />
              </div>

              {selectedFileData !== null && showDropdown === true && (
                <div className="z-10 absolute top-16 -left-8 bg-gray-800  p-1 rounded-sm">
                  <div className="flex  flex-col space-y-1 h-full p-2">
                    {allMetricsData &&
                      allMetricsData?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => handleSelectFile(item.file_name)}
                            className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                          >
                            {item.file_name}
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              <div
                onClick={handleShowModal}
                className={` cursor-pointer flex items-center font-semibold text-white space-x-2 bg-[#07F2C7]/20 px-6 py-2 rounded-md `}
              >
                Upload File
              </div>
            </div>
          )}
        </div>

        {currentTab === "portfolio" && (
          <div className="flex  justify-center items-center  w-full flex-1">
            <FileUpload />
          </div>
        )}

        {currentTab === "metrics" && (
          <div className="flex  w-full flex-1">
            {allMetricsData !== null ? (
              <div className="flex flex-col w-full px-6">
                <TradeMetrics
                  fileName={selectedFile}
                  strategyList={selectedFileStrategyList}
                  allMetricsData={allMetricsData}
                  filteredTradeData={filteredTradeData}
                  filteredMetricsData={filteredMetricsData}
                  filteredMonthlyPNLData={filteredMonthlyPNLData}
                  filteredWeeklyPNLData={filteredWeeklyPNLData}
                  filteredDayWisePNLData={filteredDayWisePNLData}
                  handleFilterData={handleFilterData}
                  handleResetFilter={handleResetFilter}
                  selectedStrategy={selectedStrategy}
                  setSelectedStrategy={setSelectedStrategy}
                />
                //{" "}
              </div>
            ) : (
              <div className="text-lg font-medium text-white/70 flex w-full justify-center items-center">
                No Trade Metric Available
              </div>
            )}
          </div>
        )}

        {currentTab === "metrics" && showModal && (
          <GenerateMetrics
            setShowModal={setShowModal}
            handleCloseModal={handleCloseModal}
          />
        )}
      </div>
    </DashboardLayout>
  );
}

// const fetchData = () => {
//   console.log("Final",finalMockData)
//   setAllMetricsData(finalMockData);
//   setSelectedFile(finalMockData[0].file_name);
//   setSelectedFileData(finalMockData[0].trade_metrics);
//   setSelectedFileStrategyList(finalMockData[0].strategy_list);

//   setFilteredMetrcisData(finalMockData[0].trade_metrics.metrics_data);

//   setFilteredMonthlyPNLData(
//     finalMockData[0].trade_metrics.monthly_pnl_data
//   );

//   setFilteredWeeklyPNLData(finalMockData[0].trade_metrics.weekly_pnl_data);

//   setFilteredDayWisePNLData(finalMockData[0].trade_metrics.day_wise_pnl);
// };
